import type { OrganizationMembership } from '@shared/types/entities';

/** Never infer the CMS owner from a Stripe plan. Explicit selection is required. */
export function resolveSiteMembership(
  memberships: OrganizationMembership[] | undefined,
  requestedId?: number,
): OrganizationMembership | null {
  const list = memberships ?? [];
  if (requestedId !== undefined) {
    return list.find(item => item.organizationId === requestedId) ?? null;
  }
  return list.length === 1 ? list[0] : null;
}

export function parseSiteOwnerId(raw: string | null): number | undefined {
  if (raw === null || raw.trim() === '') return undefined;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : undefined;
}
